import styled from 'styled-components';
import bundleBg from '../../../../static/img/bundle-banner/bundle-banner-bg.png';

const DESKTOP_BREAKPOINT = '768px';

export const BannerRoot = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  /* Fallback fill if the background image fails to load. */
  background: linear-gradient(135deg, #0b0d0c 0%, #101214 26%, #0f6638 100%);

  /* Banner background exported from the Figma "Background" copy (gradient + green facet shades). */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background: url(${bundleBg}) center center / cover no-repeat;
  }

  /* Mirror the background shades to the cards' side in RTL. */
  [dir='rtl'] &::before {
    transform: scaleX(-1);
  }

  @media only screen and (min-width: ${DESKTOP_BREAKPOINT}) {
    min-height: 160px;
    padding: 24px 32px;
    justify-content: center;
  }
`;

export const BannerContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;

  @media only screen and (min-width: ${DESKTOP_BREAKPOINT}) {
    max-width: 60%;
  }
`;

export const BannerHeadingGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BannerHeadingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const BannerHeading = styled.h3`
  margin: 0;
  color: #ffffff;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.2;

  @media only screen and (min-width: ${DESKTOP_BREAKPOINT}) {
    font-size: 24px;
  }
`;

export const BannerSubtext = styled.p`
  margin: 0;
  color: #f5f5f5;
  font-weight: 500;
  font-size: 13px;
  line-height: 1.3;

  @media only screen and (min-width: ${DESKTOP_BREAKPOINT}) {
    font-size: 16px;
    line-height: 1.2;
  }
`;

export const CtaButton = styled.button`
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 20px;
  border: 1px solid transparent;
  border-radius: 4px;
  /* White fill with a subtle teal gradient border (Figma node 1:116). */
  background:
    linear-gradient(#ffffff, #ffffff) padding-box,
    linear-gradient(180deg, #009fac 0%, #018893 100%) border-box;
  color: #1f1f1f;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background:
      linear-gradient(#f4f6f6, #f4f6f6) padding-box,
      linear-gradient(180deg, #009fac 0%, #018893 100%) border-box;
  }

  svg {
    display: block;
  }

  [dir='rtl'] & svg {
    transform: scaleX(-1);
  }
`;

export const BannerCards = styled.img`
  display: none;

  @media only screen and (min-width: ${DESKTOP_BREAKPOINT}) {
    display: block;
    position: absolute;
    inset-inline-end: 16px;
    inset-block-end: -52px;
    height: 220px;
    width: auto;
    max-width: 46%;
    object-fit: contain;
    object-position: bottom;
    pointer-events: none;
    z-index: 0;
  }
`;
